<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-8 col-8 mb-1">
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-edit"></i> Details
            </button>
            <download-excel
              :data="selectedItems"
              name="LASActivityRewardTransaction-selected-transaction.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export selected
              </button>
            </download-excel>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    brand
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    transaction date
                  </label>
                  <div class="col-sm-3">
                    <date-picker
                      v-model="timeFilter"
                      range
                      confirm-text="confirm"
                      confirm
                      editable
                      clearable
                      :default-value="timeFilter"
                      value-type="YYYY-MM-DD"
                      @confirm="onDateFilterSubmit"
                      id="DateRange"
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                  <label
                    class="col-form-label form-control-label text-sm pl-0"
                    >{{ ConditionFilterModel }}</label
                  >
                  <div class="col-sm-4 ml-0">
                    <input
                      v-model="ValueFilterModel"
                      class="form-control mx-input"
                    />
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Prize Type
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PrizeTypeModel"
                      :options="PrizeTypeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onSearchExport"
                    class="btn btn-warning ml-2"
                  >
                    <i class="fa fa-download"></i> Search and Export
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @on-all-select-rows="onSelectAllRow"
        >
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalCreate" modal-classes="modal-md">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} LAS ACTIVITY REWARD TRANSACTION
      </h3>
      <table class="table table-striped">
        <tr>
          <td>Brand</td>
          <td>{{ this.LASActivityRewardModel.brand_code }}</td>
        </tr>
        <tr>
          <td>Transaction Id</td>
          <td>{{ this.LASActivityRewardModel.transaction_id }}</td>
        </tr>
        <tr>
          <td>Reference No</td>
          <td>{{ this.LASActivityRewardModel.reference_no }}</td>
        </tr>
          <tr>
          <td>User Sitefinity Raffle Id</td>
          <td>{{ this.LASActivityRewardModel.sitefinity_user_id }}</td>
        </tr>
        <tr>
          <td>Profile Id</td>
          <td>{{ this.LASActivityRewardModel.profile_id }}</td>
        </tr>
        <tr>
          <td>Transaction Type</td>
          <td>{{ this.LASActivityRewardModel.transaction_type }}</td>
        </tr>
        <tr>
          <td>Prize Type</td>
          <td>{{ this.LASActivityRewardModel.prize_type }}</td>
        </tr>
        <tr>
          <td>Prize Id</td>
          <td>{{ this.LASActivityRewardModel.prize_id }}</td>
        </tr>
        <tr>
          <td>Prize Name</td>
          <td>{{ this.LASActivityRewardModel.prize_name }}</td>
        </tr>
        <tr>
          <td>Reward Value</td>
          <td>{{ this.LASActivityRewardModel.prize_value }}</td>
        </tr>
        <tr>
          <td>Claim Status</td>
          <td>{{ this.LASActivityRewardModel.claim_status }}</td>
        </tr>
        <tr>
          <td>Create Date</td>
          <td>{{ this.LASActivityRewardModel.create_date_utc }}</td>
        </tr>
        <tr>
          <td>Modify Date</td>
          <td>{{ this.LASActivityRewardModel.modify_date_utc }}</td>
        </tr>
        <tr></tr>
      </table>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import "vue2-datepicker/index.css";
// import BarChart from "../components/Charts/BarChart";
import NProgress from "nprogress";
import axios from "axios";

export default {
  name: "configList",
  data() {
    return {
      SummaryData: [],
      // chartDate: [],
      // chartDataSource: { labels: [], datasets: [] },
      totalItems: 0,
      totalPages: 0,
      isCompletedLoadAllItems: false,
      nextToken: null,
      ListNextToken: [],
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      IsConditionFilterDisabled: true,
      BrandCodeModel: "PHFortune",
      ChartBrandCodeModel: "PHFortune",
      DateRangeModel: null,
      ValueFilterModel: "",
      PropertyFilterModel: "reference_no",
      ConditionFilterModel: "is",
      PropertyFilterList: [
        { text: "Reference No", value: "reference_no" },
        { text: "Transaction Id", value: "transaction_id" },
        { text: "profile id", value: "profile_id" },
        { text: "User Sitefinity Raffle Id", value: "sitefinity_user_id" },
        { text: "transaction name", value: "transaction_name" },
        { text: "transaction type", value: "transaction_type" },
      ],
      showLoadButton: true,
      timeFilter: [],
      filter: {
        brand_code: "",
        transaction_id: "",
        reference_no: "",
        start_date: "",
        end_date: "",
        profile_id: "",
        sitefinity_user_id:"",
        transaction_name: "",
        transaction_type: "",
        prize_type: "",
      },
      allTransaction: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      titlePopup: "Create",
      message: null,
      PrizeTypeModel: "",
      PrizeTypeOption: [
        { text: "All", value: "" },
        { text: "Voucher", value: "Voucher" },
        { text: "Items", value: "Items" },
        { text: "Mobile Load", value: "Mobile_Load" },
      ],
      LASActivityRewardModel: {
        id: "",
        reference_no: "",
        brand_code: "",
        profile_id: "",
        sitefinity_user_id:"",
        transaction_id: "",
        transaction_type: "",
        transaction_name: "",
        prize_type: "",
        prize_id: "",
        prize_name: "",
        prize_value: 0,
        claim_status: "",
        create_date_utc: "",
        modify_date_utc: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Reference No",
          name: "reference_no",
          row_text_alignment: "text-left",
        },
        {
          label: "Transaction Id",
          name: "transaction_id",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "User Sitefinity Raffle Id",
          name: "sitefinity_user_id",
          sort: true,
        },
        {
          label: "Profile Id",
          name: "profile_id",
          sort: true,
        },
        {
          label: "Transaction Type",
          name: "transaction_type",
          sort: true,
        },
        {
          label: "Transaction Name",
          name: "transaction_name",
          sort: true,
        },
        {
          label: "Prize Type",
          name: "prize_type",
          sort: true,
        },
        {
          label: "Prize Name",
          name: "prize_name",
          sort: true,
        },
        {
          label: "Prize Value",
          name: "prize_value",
          sort: true,
        },
        {
          label: "Claim Status",
          name: "claim_status",
          sort: true,
        },
        {
          label: "Created Date",
          name: "create_date_utc",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    this.filter.start_date = filterStartDate;
    this.filter.end_date = filterEndDate;
    this.DateRangeModel = {
      start_date: filterStartDate,
      end_date: filterEndDate,
    };
    this.onLoadData();
    this.selectedItems.push(this.LASActivityRewardModel);
    // this.chartDate.push(filterStartDate);
    // this.chartDate.push(filterEndDate);
  },
  methods: {
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') && 
        object.menu.toLowerCase().includes('lasactivityrewardtransactionreport')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('lasactivityrewardtransactionreport')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe) {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune) {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }
    },
    onResetFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        transaction_id: "",
        reference_no: "",
        transaction_name: "",
        transaction_type: "",
        profile_id: "",
        sitefinity_user_id:"",
        prize_type: this.PrizeTypeModel,
      };

      this.onLoadData();
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "id";
      this.ConditionFilterModel = "is";
    },
    onSearchFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        transaction_id: "",
        reference_no: "",
        transaction_name: "",
        transaction_type: "",
        profile_id: "",
        sitefinity_user_id:"",
        prize_type: this.PrizeTypeModel,
      };
      switch (this.PropertyFilterModel) {
        case "reference_no":
          this.filter.reference_no = this.ValueFilterModel;
          break;
        case "transaction_id":
          this.filter.transaction_id = this.ValueFilterModel;
          break;
        case "sitefinity_user_id":
          this.filter.sitefinity_user_id = this.ValueFilterModel;
          break;
        case "profile_id":
          this.filter.profile_id = this.ValueFilterModel;
          break;
        case "transaction_name":
          this.filter.transaction_name = this.ValueFilterModel;
          break;
        case "transaction_type":
          this.filter.transaction_type = this.ValueFilterModel;
          break;
        default:
          break;
      }
      this.onLoadData();
    },
    async onSearchExport() {
      this.onSearchFilter();
      NProgress.start();
      try {
        let response = await API.graphql({
          query: queries.exportLASActivityRewardTransactions,
          variables: {
            filter: this.filter,
            filename: "LASActivityRewardTransReport",
          },
        });
        var presign = response.data.exportLASActivityRewardTransactions;

        let date_ob = new Date();
        let date = ("0" + date_ob.getDate()).slice(-2);
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
        let year = date_ob.getFullYear();
        let minutes = date_ob.getMinutes();
        let second = date_ob.getSeconds();
        var filename= `LASActivityRewardTransactionReport_${year}-${month}-${date}-${minutes}${second}.csv`;
        
        axios
          .get(presign, { responseType: 'arraybuffer' })
          .then((response) => {
            const a = document.createElement("a");
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            console.log('end download');
          })

        NProgress.done();
        //document.location.href = presign;
      } catch (error) {
        console.log(error);
        NProgress.done();
      }
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.start_date = momStart;
      this.filter.end_date = momEnd;
      this.DateRangeModel = {
        start_date: momStart,
        end_date: momEnd,
      };
    },
    // onChartDateChanged(value) {
    //   let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
    //   let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
    //   this.chartDate.push(momStart);
    //   this.chartDate.push(momEnd);
    //   this.chartInit();
    // },
    async onLoadData(selectedPage) {
      try {
        NProgress.start();
        
        var startDate = this.DateRangeModel.start_date + " 00:00:00";
        this.filter.start_date = this.$moment(
          new Date(startDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();
        var endDate = this.DateRangeModel.end_date + " 23:59:59";
        this.filter.end_date = this.$moment(
          new Date(endDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();

        this.filter.brand_code = this.BrandCodeModel;
        this.currentPage = selectedPage ? selectedPage : 1;
        let response = await API.graphql({
          query: queries.listEmsLASActivityRewardTransactionsPagination,
          variables: {
            pageSize: this.itemPerPage,
            pageNumber: this.currentPage,
            filter: this.filter,
          },
        });
        this.rows =
          response.data.listEmsLASActivityRewardTransactionsPagination.items;
        this.totalPages =
          response.data.listEmsLASActivityRewardTransactionsPagination.totalPages;
        this.totalItems =
          response.data.listEmsLASActivityRewardTransactionsPagination.totalItems;
        this.allTransaction = this.rows;
        NProgress.done();
      } catch (error) {
        NProgress.done();
        console.log(error);
      }
    },
    onSelectAllRow(payload) {
      this.selectedItems = payload.selected_items;
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      console.log(this.selectedItems);
      if (
        payload.selected_items.length > 1 ||
        payload.selected_items.length == 0
      ) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.LASActivityRewardModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
  },
  components: {
    VueBootstrap4Table,
    // BarChart,
  },
  watch: {
    PropertyFilterModel: function (val) {
      // if (val == "pack_code" || val == "is_rewarded") {
      //   this.ConditionFilterModel = "contains";
      // this.IsConditionFilterDisabled = false;
      //} else {
      //this.ConditionFilterModel = "is";
      // this.IsConditionFilterDisabled = false;
      //}
      this.ConditionFilterModel = "is";
      console.log(val);
    },
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
    currentPage: function () {
      this.onLoadData(this.currentPage);
    }
  },
};
</script>
<style></style>
